
import { Component, Emit, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import Button from '../../Button.vue';
// import ExportExcelButton from './ExportExcelButton.vue';
import $ from 'jquery';
import {defaultTableFilter, tableSort, watchClass, itemsPerPageOptionsTable }from '../../../../../../features/typescript/table/table-utils';
import { formatDate } from '../../../../../../features/core/utils/date-handlers';
import { formatCommaSeparatedStringList } from '../../../../../../features/typescript/table/table-formatters';
import Sortable from 'sortablejs'
import isEqual from 'lodash/isEqual'
import vColumnsResizable from '../../../../../../plugins/vue-columns-resizable'
import CustomTablePagination, { maxPageSize } from './CustomTablePagination.vue';
import { sortType } from './Table';

@Component({
    directives: {
        'v-columns-resizable': vColumnsResizable,
        'sortable-table': {
            inserted: (el, binding) => {
                el.querySelectorAll('th').forEach((draggableEl) => {
                    watchClass(draggableEl, 'sortHandle');
                    draggableEl.classList.add('sortHandle');
                });
                Sortable.create(el.querySelector('tr'), binding.value ? { ...binding.value, handle: '.sortHandle' } : {});
            }
        }
    },
    components: {
        Button,
        //ExportExcelButton,
        CustomTablePagination
    }
})
export default class SimpleTable extends Vue {
    @Prop({ default: '' }) search: string;
    @Prop() sortBy: string[];
    @Prop() sortDesc: boolean[];
    @Prop({default: false}) isSowing: boolean;
    @Prop({default: false}) enableExportExcel: boolean;
    @Prop({default: false}) enableAck: boolean;
    @Prop({default(){return itemsPerPageOptionsTable}}) itemsPerPageOptions: Array<number>;
    @Prop({default(){return []}}) items: Array<object>;
    @Prop() customSlots: any;
    @Prop() headers: any;
    @Prop() customColumns: any;
    @Prop() selectable: boolean;
    @Prop() itemKey: string;
    @Prop({ default: 'truncate-row' }) itemClass: string;
    @Prop({ default: '' }) customClass: string;
    @Prop({ default: '' }) excelFileName: string;
    @Prop({ default(){return []} }) excelSheets: string[];
    @Prop({ default: 'No data' }) noDataText: string;
    @Prop({ default: 'No hay coincidencias' }) noResultsText: string;
    @Prop() editRow: boolean;
    @Prop({ default: '' }) disableModifyReason: string;
    @Prop({ default: 'Editar' }) editRowTitle: string;
    @Prop({ default: '' }) removeRowTooltip: string;
    @Prop({default: false}) singleSelect: boolean;
    @Prop({default: false}) createFromThis: boolean;
    @Prop({default: false}) hideAllPagination: boolean;
    @Prop({default: false}) disablePagination: boolean;
    @Prop() deleteRow: boolean;
    @Prop() loading: boolean;
    @Prop({ default: false }) hideDefaultFooter: boolean;
    @Prop({ default: false }) addItem: boolean;
    @Prop({ default: false }) excludeRow: boolean;
    @Prop({ default: 'Excluir' }) excludeRowTitle: boolean;
    @Prop({ default: 'Agregar' }) addItemTitle: boolean;
    @Prop({ default: false }) checkRow: boolean;
    @Prop({ default: false }) download: boolean;
    @Prop({ default: '' }) downloadIcon: string;
    @Prop({ default: false }) keepSelecteditemsOnSearch: boolean;
    @Prop({ default: false }) fixedHeader: boolean;
    @Prop({ default() {return []}}) selectableItems: Array<object>;
    @Prop({ default() {return []}}) savedFilters: string[];
    @Prop({ default: false }) modifyRow: boolean;
    @Prop({ default: false }) seeOnMap: boolean;
    @Prop({ default: false }) disabledRow: boolean;
    @Prop({ default: false }) enableCustomPagination: boolean;
    @Prop({ default: false }) scrollableWrapper: boolean;
    currentTablePage: number = 1;
    @Prop({ default: undefined }) height: number | string;
    @Prop({ default: 1 }) paginationTotalPages: number;
    @Prop({ default: 0 }) paginationTotalRows: number;
    @Prop({ default: 1 }) paginationCurrentPage: number;
    @Prop({ default: undefined }) customSort: Function;
    @Prop({ default: undefined }) customFilter: Function;
    @Prop({ default: undefined }) options: any;
    @Prop({ default: 0 }) substractValueWhileDragging: number;
    tableOptions: object = {};
    anIncreasingNumber: number = 1;
    selectedItems: Array<object> = [];
    sortByTable: string[] = [];
    sortDescTable: boolean[] = [];
    checkboxValue: boolean = false;
    firstTime: boolean = true;
    filteredTableItems: Array<object> = [];
    tableItemsPerPage: number = 15;
    previousOptions: object = {};

    updateTableItemsPerPage(value){
        this.tableOptions = {
            ...this.tableOptions,
            itemsPerPage: value
        }
    }

    updatePaginatedTableSort(sortBy: string[], sortDesc: boolean[]){
        this.tableOptions['sortBy'] = sortBy;
        this.tableOptions['sortDesc'] = sortDesc;
    }

    updateTablePage(page){
        let direction = page > this.currentTablePage ? 'fordward' : 'backwards';
        this.currentTablePage = page;
        let tableEl = this.$refs.table as HTMLFormElement
        let itemsPerPage = tableEl.computedItemsPerPage;
        this.getNewRows(page, itemsPerPage, direction);
    }

    @Emit()
    doubleClickEvent(event, item){}

    @Emit()
    getNewRows(page, pageSize, direction){}

    @Emit()
    rightClickEvent(event, clickedRow){}

    @Emit()
    markToCalibrate(item) {}

    @Emit()
    modifyAction(item) {}

    @Emit()
    markToLevMap(item) {}

    @Emit()
    ackAction(value) {}

    updateSelectedItems(rows){
        this.selectedItems = rows;
    }
    
    @Emit()
    addAction(value) {}

    @Emit()
    removeAction(item) {}

    @Emit()
    uncalibrateVehicle(item) {}

    @Emit()
    unforceLevMap(item) {}

    @Watch('paginationCurrentPage', { immediate: true, deep: true })
    observablePaginationPage(value) {
        this.currentTablePage = value;
    }
    @Watch('selectableItems')
    clearAllSelectedItems(value) {
        if (value.length == 0) {
            this.selectedItems = [];
        }
    }

    formatList(value){
        return formatCommaSeparatedStringList(value)
    }

    @Watch('search')
    observableSearch() {
        if(!this.keepSelecteditemsOnSearch){
            this.selectedItems = [];
        }
    }

    @Watch('sortBy', { immediate: true, deep: true })
    observableSortBy(value) {
        this.sortByTable = value;
    }
    @Watch('options', { immediate: true, deep: true })
    observableOptions(value) {
        this.tableOptions = value;
    }

    @Watch('sortDesc', { immediate: true, deep: true })
    observableSortDesc(value) {
        this.sortDescTable = value;
    }

    @Watch('items', { immediate: true, deep: true })
    observableItems(items) {
        this.updateRowTooltips();
        this.updateRowsEnabledKey(items);
    }

    updateRowsEnabledKey(items) {
        let self = this;
        if (items.length !== 0 && this.disabledRow) {
            items = items.map(function(item) {
                if (item['enabled'] == undefined) {
                    item['enabled'] = true;
                }
                if (self.firstTime) {
                    if (item['disableDelete'] == undefined) {
                        item['disableDelete'] = true;
                    }
                }
            });
        }
    }



    @Watch('itemClass', { immediate: true, deep: true })
    observableItemClass() {
        this.updateRowTooltips();
    }

    @Emit()
    editAction(item) {
        return item;
    }

    @Emit()
    downloadAction(item) {
        return item;
    }

    @Emit()
    excludeAction(item) {
        return item;
    }

    @Emit()
    checkBoxAction(item) {
        return item;
    }

    disabledRowAction(item) {
        return item;
    }

    @Emit()
    createFileFromThis(item) {
        return item;
    }

    @Emit()
    selectedRows() {}

    @Emit()
    filteredItems(items) {
        this.filteredTableItems = items;
        let tableItems = this.$refs.table as HTMLFormElement;
        if (tableItems) {
            let tableRef: any = this.$refs.table;
            this.filteredTableItems = tableRef.$children[0].filteredItems; 
        }
        this.updateRowTooltips();
        return this.filteredTableItems
    }

    @Emit()
    clickRow(item) {
        return item;
    }
    
    onUpdatedTableOptions(options) {
        
        if (options.itemsPerPage == maxPageSize) {
            options.page = 1;
        }

        if (isEqual(options, this.previousOptions)) {
            return;
        }

        if(Object.keys(this.previousOptions).length === 0 && this.enableCustomPagination){
            options.sort_by = this.sortBy
            options.sort_desc = this.sortDesc
        }
        this.previousOptions = options;
        
        this.$emit('updated-table-options', options);
        return options;
    }

    @Emit()
    deleteAction(item) {
        return item;
    }

    @Emit()
    updatedHeaders(headers) {}

    @Emit()
    seeOnmapAction(item) {
        return item;
    }

    rowClass(item){
        let rowCss = 'truncate-row';
        if(item && item.added || item && item.assigned){
            rowCss += ' table-row-green'
        }else if(item && item.overload || item.has_geofence == false){
            rowCss += ' table-row-warning'
        }else if(item && item['gray_row']){
            rowCss += ' table-row-gray'
        } else{
            rowCss += ' table-row-white'
        }
      return rowCss
    }

    sortTheHeadersAndUpdateTheKey(evt) {
        const headersTmp = this.headers;
        const oldIndex = evt.oldIndex - this.substractValueWhileDragging;
        const newIndex = evt.newIndex - this.substractValueWhileDragging;
        // console.log("old index", oldIndex);
        // console.log("newIndex index", newIndex);

        // Si el nuevo index es mayor al tamaño del array, se agregan elementos undefined
        //para que el splice no tire error
        if (newIndex >= headersTmp.length) {
            let k = newIndex - headersTmp.length + 1;
            // console.log("k", k);
            while (k--) {
                headersTmp.push(undefined);
            }
        }
        // console.log("headersTmp updateados", headersTmp);

        // Se mueve el elemento de la posición vieja a la nueva
        let header = headersTmp.splice(oldIndex, 1)[0];
        // console.log("header a mover", header);
        headersTmp.splice(newIndex, 0, header);
        // Filtrar los elementos undefined al final del array
        const filteredHeaders = headersTmp.filter(header => header !== undefined);
        this.updatedHeaders(filteredHeaders);
        this.increaseTableKey();
    }

    increaseTableKey() {
        this.anIncreasingNumber += 1;
    }

    updateRowTooltips() {
        setTimeout(() => {
            $('.truncate-row')
                .find('td')
                .addClass('truncate-text');
            $('.truncate-text').each(function() {
                
                    let text = $(this).text();
                    text = text.split('\\s\\s+');
                    $(this).attr('title', text);

                    if ($(this).attr('title') === 'check_box_outline_blank'){
                        $(this).removeAttr('title')
                    }
                
            });
        }, 0);
    }

    toggleSelectAll(event) {
        let self = this;
        let tableRef: any = this.$refs.table;
        let filteredRows = tableRef.$children[0].filteredItems; 
        //si se aplica algun filtro se almacenan en filteredRows los resultados
        if (event.value) {
            // alert('selected all')
            if (filteredRows.length) {
                this.updateSelectedItems(filteredRows);
            } else {
                this.updateSelectedItems(this.items);
            }
        } else {
            this.updateSelectedItems([]);
            // alert('deselected all')
        }
    }

    format(date: string) {
        return formatDate(date);
    }

    mounted() {
        let self = this;
        this.$nextTick(() => {
            self.updateRowTooltips();
            self.filteredItems(this.items);
            let tableRef: any = this.$refs.table;
            if(tableRef){
                self.tableOptions = tableRef.options;
                self.currentTablePage = tableRef.page;
            }
            
            
            setTimeout(() => {
                self.firstTime = false;
                self.increaseTableKey();
            }, 2000);
        });
    }

    customSortTable(items: object[], sortBy: string[], sortDesc: boolean[]) {
        if(this.enableCustomPagination){
            return items
        }
        if(this.customSort !== undefined){
            return this.customSort(items, sortBy, sortDesc);
        }
        return tableSort(items, sortBy, sortDesc);
    }
    customFilterTable(value: any, search: string | null, item: any) {
        if(this.savedFilters.length > 0) return true

        if(this.customFilter !== undefined){
            return this.customFilter(value, search, item);
        }
        
        return defaultTableFilter(value, search, item)
    }
}
